module.exports = "<div class=\"row\" [hidden]=\"message === undefined || message.type != 'loading'\">\r\n    <div class=\"progress\" role=\"progressbar\" style=\"position:absolute; top:-20px; width:100%; height:4px;\">\r\n        <div class=\"progress-bar progress-bar-striped active indeterminate\" style=\"height:100%;\"></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/progress/progress.component.html
// module id = 1096
// module chunks = 0